<div>
    <app-jc3-block-1 [whatsNewData]="whatsNewData"></app-jc3-block-1>

    <app-jc3-block-2 [esgData]="esgData"></app-jc3-block-2>

    <app-jc3-block-3 [esgData]="whyEsgData"></app-jc3-block-3>

    <app-jc3-block-4 [gsData]="startedjc3Data"></app-jc3-block-4>

    <!-- [successConfData]="successConfData" -->
    <app-jc3-block-5
        [successStoriesData]="successStoriesData"
    ></app-jc3-block-5>

    <app-jc3-block-6></app-jc3-block-6>
</div>
